import { gql } from '@apollo/client';

import { ROLE } from '@/core/constants/app-constants';
import { ProfileConfigurationEnum } from '@/ux-legacy/experience/edit-profile/EditProfileTypes';

import { UserProfileData } from '../store/global/app-data-type';
import { getApolloClient } from './graphql';

export async function getProfiles(GRAPHQL: string | undefined, token?: string) {
  const gqlClient = getApolloClient(GRAPHQL, token);
  return gqlClient.query({
    query: gql`
      {
        getProfiles(limit: 20, skip: 0) {
          id
          gURL
          inMagnets
          outMagnets
          payload {
            fieldName
            value
          }
          customType {
            id
            name
            description
            createdAt
          }
          createdAt
          createdByProfile {
            id
            gURL
            inMagnets
            outMagnets
            createdAt
          }
        }
      }
    `,
  });
}

export async function fetchLoggedInUserInteraction(
  GRAPHQL: string | undefined,
  connectionName: string,
  fromId: string | null,
) {
  const gqlClient = getApolloClient(GRAPHQL);

  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
      {
        fetchMyInteractions(
          limit: 20
          skip: 0
          FetchMyInteractionInput: { 
            profileId: "${localStorage.getItem('defaultProfile')}"
            alias:"${connectionName}", 
            fromId:"${fromId}" 
          }
        ) {
          data
        }
      }
      `,
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function fetchAllTransactions(
  tenantId: string,
  GRAPHQL: string | undefined,
  productTemplate: string,
  UserIds: string[] = [],
  productId: string[] = [],
  marketPlaceIds: any[] = [],
  limit = 9,
  skip = 0,
  membershipStatuses?: any,
) {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query fetchTransaction(
          $productTemplate: TransactionTemplate!
          $tenantId: String!
          $productIds: [String!]
          $marketPlaceIds: [String!]
          $UserIds: [String!]
          $skip: Int!
          $limit: Int!
          $membershipStatuses: [MembershipStatusForFetchTransaction!]
        ) {
          fetchTransaction(
            input: {
              productTemplate: $productTemplate
              tenantId: $tenantId
              productIds: $productIds
              marketPlaceIds: $marketPlaceIds
              UserIds: $UserIds
              skip: $skip
              limit: $limit
              membershipStatuses: $membershipStatuses
            }
          ) {
            BasicDetails {
              Name
              No_Of_Adults
              No_Of_Children
              Status
              Start_Date
              End_Date
              Next_Payment_Due_Date
              Recurring_Payment_Applicable
              Amount
              Id
              Agreement_Id
            }
            User {
              Name
              Email
              MembershipStatus
              ProfileImageURL
              Id
              QrCode
            }
            Product {
              Product_Details {
                Product_Name
                Product_Image
                Product_Type
                Product_Price
                Product_Id
                Id
              }
              Service_Space_Id
            }
            PaymentDetails {
              Agreement_Id
              Order_Id
              Status
              Amount
              Payment_Date
            }
          }
        }
      `,
      variables: {
        productTemplate,
        tenantId,
        productIds: productId,
        UserIds,
        marketPlaceIds,
        skip,
        limit,
        membershipStatus: membershipStatuses != 'ALL' ? membershipStatuses : null,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function SearchUser(tenantId: string, GRAPHQL: string | undefined, fullName: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query searchByFullName($tenantId: String!, $fullName: String!) {
          searchByFullName(
            UserSearchInput: { fullName: $fullName, tenantId: $tenantId, skip: 0, limit: 10 }
          ) {
            id
            fullName
            email
            tenantId
            phone
            isPhoneVerified
            isEmailVerified
            profiles {
              id
              Name
              Email
              DisplayPic
              ZipCode
              City
              Country
              Address
              Allergies
              Age
              Relationship
              _metadata {
                IsEmailVerified
              }
              _type
              _created_at
              _last_modified
            }
          }
        }
      `,
      variables: { tenantId, fullName },
    });
  }
}

export async function assignProfileToTicket(
  tenantId: string,
  GRAPHQL: string | undefined,
  spaceId: string,
  profileId: string,
) {
  const gqlClient = getApolloClient(GRAPHQL);

  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation assignProfileToTicket($tenantId: String!, $SpaceId: String!, $ProfileId: String) {
          assignProfileToTicket(
            ticketAndCheckInInput: { TenantId: $tenantId, SpaceId: $SpaceId, ProfileId: $ProfileId }
          ) {
            message
            connectedProfileId
            connectedWithSpaceId
          }
        }
      `,
      variables: {
        tenantId,
        SpaceId: spaceId,
        ProfileId: profileId,
      },
    });
  }
}

export async function removeProfileFromTicket(
  tenantId: string,
  GRAPHQL: string | undefined,
  spaceId: string,
  profileId: string,
) {
  const gqlClient = getApolloClient(GRAPHQL);

  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation removeProfileFromTicket($tenantId: String!, $SpaceId: String!, $ProfileId: String) {
          removeProfileFromTicket(
            ticketAndCheckInInput: { TenantId: $tenantId, SpaceId: $SpaceId, ProfileId: $ProfileId }
          ) {
            message
            connectedProfileId
            connectedWithSpaceId
          }
        }
      `,
      variables: {
        tenantId,
        SpaceId: spaceId,
        ProfileId: profileId,
      },
    });
  }
}

export async function getAllProfiles(GRAPHQL: string | undefined, token?: string) {
  const gqlClient = getApolloClient(GRAPHQL, token);
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        {
          getAllProfiles {
            id
            Name
            Email
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      `,
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function createNormalProfile(GRAPHQL: string | undefined, data: UserProfileData) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation createNormalProfile(
          $Name: String!
          $Email: String!
          $Address: String
          $Age: Int
          $City: String
          $Relationship: String
          $Allergies: [String!]
          $Country: String
          $PhoneNumber: String
          $ZipCode: String
          $DisplayPic: String
        ) {
          createNormalProfile(
            CreateNormalProfileInput: {
              Name: $Name
              Email: $Email
              Address: $Address
              Age: $Age
              City: $City
              Relationship: $Relationship
              Allergies: $Allergies
              Country: $Country
              PhoneNumber: $PhoneNumber
              ZipCode: $ZipCode
              DisplayPic: $DisplayPic
            }
          ) {
            id
            Name
            Email
            PhoneNumber
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsPhoneNumberVerified
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      `,
      variables: {
        ...data,
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function updateNormalProfile(GRAPHQL: string | undefined, data: UserProfileData) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation updateNormalProfile(
          $id: String!
          $Name: String!
          $Email: String!
          $Address: String
          $Age: Int
          $City: String
          $Relationship: String
          $Allergies: [String!]
          $Country: String
          $PhoneNumber: String
          $ZipCode: String
          $DisplayPic: String
        ) {
          updateNormalProfile(
            updateMasterProfileInput: {
              id: $id
              Name: $Name
              Email: $Email
              Address: $Address
              Age: $Age
              City: $City
              Relationship: $Relationship
              Allergies: $Allergies
              Country: $Country
              PhoneNumber: $PhoneNumber
              ZipCode: $ZipCode
              DisplayPic: $DisplayPic
            }
          ) {
            id
            Name
            Email
            PhoneNumber
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsPhoneNumberVerified
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      `,
      variables: data,
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function updateMasterProfile(GRAPHQL: string | undefined, id: string, data: UserProfileData) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation updateMasterProfile(
          $Name: String
          $Address: String
          $Age: Int
          $City: String
          $Allergies: [String!]
          $Country: String
          $ZipCode: String
          $DisplayPic: String
          $Headline: String
          $BackgroundColor: String
          $Intro: String
          $SocialLinks: [String!]
        ) {
          updateMasterProfile(
            updateMasterProfileInput: {
              Name: $Name
              Address: $Address
              Age: $Age
              City: $City
              Allergies: $Allergies
              Country: $Country
              ZipCode: $ZipCode
              DisplayPic: $DisplayPic
              Headline: $Headline
              BackgroundColor: $BackgroundColor
              Intro: $Intro
              SocialLinks: $SocialLinks
            }
          ) {
            id
            Name
            Email
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            Headline
            BackgroundColor
            Intro
            SocialLinks
            _metadata {
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      `,
      variables: {
        ...data,
        id,
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function fetchTransactionById(tenantId: string, GRAPHQL: string | undefined, spaceId: string) {
  const gqlClient = getApolloClient(GRAPHQL);

  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query fetchTransactionById($tenantId: String!, $spaceId: String!) {
          fetchTransactionById(input: { tenantId: $tenantId, spaceId: $spaceId }) {
            BasicDetails {
              Name
              No_Of_Adults
              No_Of_Children
              Status
              Start_Date
              End_Date
              Next_Payment_Due_Date
              Recurring_Payment_Applicable
              Amount
              Id
              Agreement_Id
            }
            UserUpdateOutput {
              TransactionSpaceId
              Name
              Description
              Image
            }
            User {
              Name
              Email
              MembershipStatus
              ProfileImageURL
              Age
              Relationship
              City
              Country
              ZipCode
              Allergies
              Address
              Id
              QrCode
            }

            Product {
              Product_Details {
                Id
                Product_Name
                Product_Image
              }
              Service_Space_Id
            }
            PaymentDetails {
              Agreement_Id
              Order_Id
              Status
              Amount
              Payment_Date
            }
          }
        }
      `,
      variables: {
        tenantId,
        spaceId,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function fetchAllAssetTransactions(
  tenantId: string,
  GRAPHQL: string | undefined,
  productTemplate: any,
  UserIds: string[] = [],
  productId: string[] = [],
  marketPlaceIds: any[] = [],
  limit = 9,
  skip = 0,
  membershipStatuses?: any,
) {
  const gqlClient = getApolloClient();
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query fetchAllAssetTransactions(
          $productTemplate: TransactionTemplate
          $tenantId: String!
          $productIds: [String!]
          $marketPlaceIds: [String!]
          $UserIds: [String!]
          $skip: Int!
          $limit: Int!
          $membershipStatuses: [MembershipStatusForFetchTransaction!]
        ) {
          fetchAllAssetTransactions(
            input: {
              productTemplate: $productTemplate
              tenantId: $tenantId
              productIds: $productIds
              marketPlaceIds: $marketPlaceIds
              UserIds: $UserIds
              skip: $skip
              limit: $limit
              membershipStatuses: $membershipStatuses
            }
          ) {
            BasicDetails {
              Name
              No_Of_Adults
              No_Of_Children
              Status
              Start_Date
              End_Date
              Next_Payment_Due_Date
              Recurring_Payment_Applicable
              Amount
              Id
              _updatedAt
              Agreement_Id
            }
            User {
              Name
              Email
              MembershipStatus
              ProfileImageURL
              Age
              Relationship
              City
              Country
              ZipCode
              Allergies
              Address
              Id
              QrCode
            }
            Product {
              Product_Details {
                Product_Name
                Product_Image
                Product_Type
                Product_Price
                Product_Id
                Id
              }
              Service_Space_Id
            }
            PaymentDetails {
              Agreement_Id
              Order_Id
              Status
              Amount
              Payment_Date
            }
          }
        }
      `,
      variables: {
        productTemplate,
        tenantId,
        productIds: productId,
        UserIds,
        marketPlaceIds,
        skip,
        limit,
        membershipStatuses: membershipStatuses != 'ALL' ? membershipStatuses : null,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function assignRoleToProfile(GRAPHQL: string | undefined, userId: string, role: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation assignRoleToProfile($userId: String!, $role: RoleType!) {
          assignRoleToProfile(userId: $userId, role: $role) {
            id
            type
            isActive
            _created_at
            _last_modified
          }
        }
      `,
      variables: {
        userId,
        role,
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function removeRoleFromProfile(GRAPHQL: string | undefined, userId: string, role: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation removeRoleFromProfile($userId: String!, $role: RoleType!) {
          removeRoleFromProfile(userId: $userId, role: $role) {
            id
            type
            isActive
            _created_at
            _last_modified
          }
        }
      `,
      variables: {
        userId,
        role,
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function getProfilesByRoles(GRAPHQL: string | undefined, role: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query getProfilesByRole($role: RoleType!) {
          getProfilesByRole(role: $role) {
            id
            coreUserId
            Name
            Email
            DisplayPic
            ZipCode
            City
            Country
            Address
            Allergies
            Age
            Relationship
            _metadata {
              IsEmailVerified
            }
            _type
            _created_at
            _last_modified
          }
        }
      `,
      variables: {
        role,
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function getProfilesWithRoles(GRAPHQL: string | undefined) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.query({
      query: gql`
        query getProfilesByRole {
          getAllProfileWithRole {
            role
            profile {
              id
              coreUserId
              Name
              Email
              DisplayPic
              ZipCode
              City
              Country
              Address
              Allergies
              Age
              Relationship
              _metadata {
                IsEmailVerified
              }
              _type
              _created_at
              _last_modified
            }
          }
        }
      `,
      variables: {},
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

const fetchingUser: {
  userId: string | null;
  staus: null | Promise<any>;
} = {
  userId: null,
  staus: null,
};
export async function getUserDetailsById(GRAPHQL: string, id: string) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    if (fetchingUser.staus !== null && fetchingUser.userId === id) {
      return fetchingUser.staus;
    }
    const status = gqlClient.query({
      query: gql`
        query getUserDetailsByIdV2($userId: String!) {
          getUserDetailsByIdV2(input: { userId: $userId }) {
            ProfileDetails {
              id
              coreUserId
              Name
              Email
              DisplayPic
              ZipCode
              City
              Country
              Address
              _created_at
              _last_modified
              Handle
              Headline
              BackgroundColor
              Intro
              SocialLinks
              Background {
                source
                type
              }
              Theme {
                color
                layout
              }
            }
            Count
          }
        }
      `,
      variables: {
        userId: id,
      },
    });
    fetchingUser.staus = status;
    fetchingUser.userId = id;
    status.finally(() => {
      fetchingUser.staus = null;
      fetchingUser.userId = null;
    });
    return status;
  }
}

export async function upgradeRole(
  GRAPHQL: string | undefined,
  role: typeof ROLE,
  refreshToken: string,
  code: string,
) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation upgradeRole($UpgradeRoleInput: UpgradeRoleInput!) {
          upgradeRole(UpgradeRoleInput: $UpgradeRoleInput) {
            jwt
            refreshToken
          }
        }
      `,
      variables: {
        UpgradeRoleInput: {
          newRole: role,
          refreshToken,
          code,
        },
      },
    });
  }
  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function createProfileConfiguration(
  GRAPHQL: string | undefined,
  ProfileConfigurationInput: {
    background?: { type: string; source: string };
    theme?: { color: string; layout: string };
  },
) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation profileConfiguration($ProfileConfigurationInput: ProfileConfigurationInput!) {
          profileConfiguration(ProfileConfigurationInput: $ProfileConfigurationInput) {
            isActive
          }
        }
      `,
      variables: {
        ProfileConfigurationInput: ProfileConfigurationInput,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function updateProfileConfiguration(
  GRAPHQL: string | undefined,
  ProfileConfigurationInput: {
    background?: { type: string; source: string };
    theme?: { color: string; layout: string };
  },
) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation updateProfileConfiguration($ProfileConfigurationInput: ProfileConfigurationInput!) {
          updateProfileConfiguration(ProfileConfigurationInput: $ProfileConfigurationInput) {
            isActive
          }
        }
      `,
      variables: {
        ProfileConfigurationInput: ProfileConfigurationInput,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}

export async function removeProfileConfiguration(
  GRAPHQL: string | undefined,
  RemoveProfileConfigurationInput: {
    config: ProfileConfigurationEnum;
  },
) {
  const gqlClient = getApolloClient(GRAPHQL);
  if (gqlClient !== undefined) {
    return gqlClient.mutate({
      mutation: gql`
        mutation removeProfileConfiguration(
          $RemoveProfileConfigurationInput: RemoveProfileConfigurationInput!
        ) {
          removeProfileConfiguration(RemoveProfileConfigurationInput: $RemoveProfileConfigurationInput) {
            isActive
          }
        }
      `,
      variables: {
        RemoveProfileConfigurationInput,
      },
    });
  }

  return new Promise((resolve, reject) => {
    reject();
  });
}
